import { Icon } from "./Icon";
import { ICON_SIZES } from "../../hooks/useSvgAttributes";
export { Icon, ICON_SIZES };
export default Icon;
